export const composeEllipsisAriaLabelText = "u$a";
export const encryptMenuText = "v$a";
export const encryptDisableForwardingMenuText = "w$a";
export const hideFrom = "x$a";
export const switchToHTMLMenuItem = "y$a";
export const composePostButtonLabel = "z$a";
export default {composeEllipsisAriaLabelText,encryptMenuText,encryptDisableForwardingMenuText,hideFrom,switchToHTMLMenuItem,composePostButtonLabel};